import { MenuItem, Select } from '@mui/material';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

function SelectField({
    name,
    value = '',
    onChange,
    options,
    renderOptionStyle = item => null,
    ...props
}) {
    // const { register, resetField } = useFormContext();

    // useEffect(() => resetField(name, { defaultValue: value }), [value]);

    return (
        <Select
            fullWidth
            size="small"
            // defaultValue=""
            // {...register(name)}
            value={value}
            {...props}
            onChange={onChange}
        >
            {options.map(option => (
                <MenuItem
                    sx={renderOptionStyle(option)}
                    key={option.value}
                    value={option.value}
                >
                    {option.label}
                </MenuItem>
            ))}
        </Select>
    );
}

export default SelectField;
